<ng-template
  #confirmationDialog
  let-dialog
  let-dialogConfig="dialogConfig"
  [fdDialogTemplate]
>
  <fd-dialog [dialogConfig]="dialogConfig" [dialogRef]="dialog">
    <fd-dialog-header>
      <h1 fd-title id="fd-dialog-header-tpl">
        <fd-icon
          color="non-interactive"
          glyph="sys-help-2"
          id="revoke-trust-dialog-icon"
        />Confirmation
      </h1>
    </fd-dialog-header>

    <fd-dialog-body
      data-testid="dxp-extension-trust-confirm-revoke-access-dialog"
      style="padding: 2rem auto"
    >
      <p id="fd-dialog-body-tpl">
        You are about to revoke access for custom extensions added to this
        Workspace. <br />Once revoked, custom extensions will not load unless
        you grant access again.
      </p>
      <p>
        Are you sure you want to remove access for all custom extensions
        currently installed on this Workspace?
      </p>
    </fd-dialog-body>

    <fd-dialog-footer>
      <fd-button-bar
        ariaLabel="Interested Emphasized"
        data-testid="dxp-extension-trust-confirm-revoke-access-button"
        fdCompact
        fdType="emphasized"
        label="Revoke Access"
        (click)="revokeTrust(dialog)"
      />

      <fd-button-bar
        ariaLabel="Cancel"
        data-testid="dxp-extension-trust-cancel-dialog"
        fdCompact
        label="Cancel"
        (click)="dialog.dismiss('Cancel')"
      />
    </fd-dialog-footer>
  </fd-dialog>
</ng-template>

@if (trustService.showRevokeTrustButton()) {
  <button
    class="extension-trust-btn"
    data-testid="dxp-extension-trust-revoke-button"
    fd-button
    fdCompact
    label="Revoke Access"
    (click)="openDialog(confirmationDialog)"
  ></button>
}
